import React from "react";
import SingleClickToFlyContent from "../components/click-to-fly/single-click-to-fly-content";

const SingleClickToFly = () => {
  return <SingleClickToFlyContent />;
};

export default SingleClickToFly;

